export default __webpack_public_path__ + "static/media/cs7.b905f26e.png";